import {analyticsConstants} from '../../constants';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';
import {GlobalAnalyticsVariablesInterface, TrackExpenseAccountPayMethodInterface} from '../interfaces';

export const trackExpenseAccountPayMethodPayloadCase = (
  payload: any,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackExpenseAccountPayMethodInterface => {
  const data = {
    eventType: payload.eventType,
    paymentMethod: payload.paymentMethod,
    olciPassengerIds: payload.olciPassengerIds,
    fluidVariable: payload.fluidVariable,
    interaction: analyticsConstants.ONBOARD_EXPENSES.PAY_METHOD.INTERACTION,
    pageName: analyticsConstants.ONBOARD_EXPENSES.PAY_METHOD.PAGE_NAME,
  }
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
};
